import React, { useState } from "react";
import styles from "./CartItem.module.scss";
import { Product } from "../Products/Products";


const HeartIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
);

const CrossIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

interface CartItemProps {
  item: Product;
  onQuantityChange: (itemId: string, newQuantity: number) => void;
  onRemoveItem: (itemId: string) => void;
}

const CartItem: React.FC<CartItemProps> = ({ item, onQuantityChange, onRemoveItem }) => {
  const handleIncrement = () => {
    onQuantityChange(item.id, item.quantity + 1);
  };

  const handleDecrement = () => {
    if (item.quantity > 1) {
      onQuantityChange(item.id, item.quantity - 1);
    }
  };

  return (
    <div className={styles.cartItem}>
      <img src={item.image} alt={item.name} className={styles.itemImage} />
      <div className={styles.itemDetails}>
        <h3 className={styles.itemName}>{item.name}</h3>
        <p className={styles.itemArticle}>Арт. {item.article}</p>
        <button className={styles.favoriteButton}>
          <HeartIcon /> В избранное
        </button>
      </div>
      <div className={styles.itemPricePerUnit}>{item.price} р.</div>
      <div className={styles.quantitySelector}>
        <button onClick={handleDecrement} className={styles.quantityButton} disabled={item.quantity <= 1}>
          –
        </button>
        <input type="text" value={item.quantity} readOnly className={styles.quantityInput} />
        <button onClick={handleIncrement} className={styles.quantityButton}>
          +
        </button>
      </div>
      <div className={styles.itemTotalPrice}>{(item.price * item.quantity).toFixed(0)} р.</div>
      <button onClick={() => onRemoveItem(item.id)} className={styles.removeItemButton}>
        <CrossIcon />
      </button>
    </div>
  );
};

export default CartItem;
